import { Society } from 'types';
import { SocietyTypes } from 'types/Society';

export const societyHasTitles = (society?: Society): boolean => {
  if (!society || !society?.societyType) return false;

  const isValidSocietyType = [SocietyTypes.SA, SocietyTypes.SA_AXA].includes(
    society.societyType
  );

  const hasSharesTitleEnabled = society?.configuration?.sharesTitles?.enabled;

  return isValidSocietyType && (hasSharesTitleEnabled ?? false);
};
